import { CONSENT_EVENT, initializeGoogleTag } from "@/lib/googleTag";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureEntryContext, getAnalyticsSessionId, trackEvent } from "@/lib/analytics";

export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    captureEntryContext();
    const track = () => {
      initializeGoogleTag();
      const route = `${location.pathname}${location.search}`;
      const navigationId = location.key || route;
      trackEvent("landing_page_viewed", { metadata: { route } }, `landing:${getAnalyticsSessionId()}`);
      if (location.pathname === "/eksperter" || location.pathname.startsWith("/kategorier/")) {
        trackEvent("expert_list_viewed", { metadata: { route } }, `expert-list:${navigationId}`);
      }
      const match = location.pathname.match(/^\/eksperter\/([^/]+)$/);
      if (match) {
        trackEvent("expert_profile_viewed", { expert_id: match[1], metadata: { route } }, `expert-profile:${navigationId}:${match[1]}`);
      }
    };
    track();
    window.addEventListener(CONSENT_EVENT, track);
    return () => window.removeEventListener(CONSENT_EVENT, track);
  }, [location.key, location.pathname, location.search]);

  return null;
}
